import { Ear } from 'lucide-react';
import React from 'react';

import type { HeardSeek } from '../fields/types';
import { SimpleTooltipV2 } from './tooltip';

export interface HeardSeekButtonProps {
  heardSeek?: HeardSeek;
  onNavigateToCall: (callId: string, evidenceTimeStart?: string, evidenceTimeEnd?: string) => void;
  className?: string;
}

/**
 * Dedicated "heard" affordance, shown only on fields a rep confirmed verbally during a
 * call. Distinct from the extraction-evidence ReviewButton: the ear icon reads as "heard",
 * and clicking jumps to that moment in the recording/transcript via the existing seek path.
 */
export const HeardSeekButton: React.FC<HeardSeekButtonProps> = ({
  heardSeek,
  onNavigateToCall,
  className = '',
}) => {
  if (!heardSeek?.source_id || !onNavigateToCall) return null;
  return (
    <SimpleTooltipV2 content="Heard — jump to the recording">
      <button
        type="button"
        aria-label="Heard on the call — jump to the recording"
        onClick={e => {
          e.stopPropagation();
          onNavigateToCall(heardSeek.source_id, heardSeek.time_start, heardSeek.time_end);
        }}
        className={`text-amber-500 hover:text-amber-600 cursor-pointer shrink-0 ${className}`}
      >
        <Ear className="h-3.5 w-3.5" />
      </button>
    </SimpleTooltipV2>
  );
};
